<template>
  <app-header class="flex justify-between settings-item-header">
    <div class="flex flex-col w-7/12 gap-4 py-8">
      <h2 class="font-semibold">{{ title }}</h2>
      <span v-if="description" class="text-gray-dark">{{ description }}</span>
    </div>

    <transition name="slide-fade" mode="out-in">
      <base-button v-if="!isButtonHidden"
                  id="add-settings-item-button"
                  :variant="isAddingNewItem ? 'bordered-error' : 'primary'"
                  :icon="isAddingNewItem ? 'close' : 'add'"
                  :icon-size="'1.2rem'"
                  @click="handleClick"
      >
        {{ isAddingNewItem ? 'Cancel' : 'Add' }}
      </base-button>
    </transition>
  </app-header>
</template>

<script>
import AppHeader from '@/components/common/AppHeader.vue'
import BaseButton from '@/components/base-components/BaseButton.vue'

export default {
  name: 'SettingsItemHeader',

  components: {
    BaseButton,
    AppHeader
  },

  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: ''
    },
    isAddingNewItem: {
      type: Boolean,
      default: false
    },
    isButtonHidden: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    handleClick(event) {
      this.$emit('click')
      event.target.blur()
    }
  }
}
</script>

<style lang="scss">
.settings-item-header {
  height: unset !important;
}

#add-settings-item-button {
  button {
    @apply flex flex-row-reverse;
  }
}

.slide-fade-enter-active {
  transition: all .3s ease;
}

.slide-fade-leave-active {
  transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-enter, .slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}
</style>
